import React, { Component } from 'react';
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import LeftBar from '../Site/LeftBar';
import ProductVolumeDetail from './ProductVolumeDetail';

import './style.css';

class ProductVolumeMain extends Component {

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }


  constructor(props) {
    super(props);
    
    const { location } = this.props

    var pathArray = location.pathname.split('/');
    
    this.state = {        
        cl_id : pathArray[2]
    };
  }


  render() {
    return (
      <div>
        <LeftBar />
        <ProductVolumeDetail cl_id={this.state.cl_id} />
      </div>    


    );
  }
}

export default withRouter(ProductVolumeMain);